<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space add-catalog-dialog">
    <sc-dialog-title>
      {{ 'Attribute Group' | translate: ['erp.ui.articletype-attributegroup-editor.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
        <form [formGroup]="formGroup">
            <sc-flex [vertical]="true" [stretchContent]="true" style="width: 450px;">
                <sc-dictionary-field class="name-input" [model]="name" [maxlength]="255" defaultLabel="Name"
                    [required]="true" labelDictionaryKey="erp.entity.attributegroup.name"
                    (dictionaryChanged)="onNameChanged($event)">
                </sc-dictionary-field>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                  <mat-label>{{ 'Used for' | translate: ['erp.entity.attributegroup.usage',
                      translationService.language]}}</mat-label>
                  <mat-select formControlName="usage">
                      <mat-option *ngFor="let source of possibleUsages" [value]="source">
                          {{source | translate: ['erp.entity.attributegroup.usage.' + source, translationService.language]}}
                      </mat-option>
                  </mat-select>
                </mat-form-field>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'sort order' | translate: ['erp.entity.attributegroup.sort-order', translationService.language]}}</mat-label>
                    <input matInput formControlName="sortValue">
                </mat-form-field>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'group-key' | translate: ['erp.entity.attributegroup.group-key', translationService.language]}}</mat-label>
                    <input matInput formControlName="groupKey">
                </mat-form-field>
            </sc-flex>
        </form>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.articletype-attributegroup-editor.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
          {{ 'Übernehmen' | translate: ['erp.ui.articletype-attributegroup-editor.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
